import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row, Modal } from "antd";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import TitlePage from "../../../component/Desktop/titlePage";
import FooterPage from "../../../component/footer/footerPage";
import ListUnitMaster from "./list";
import ViewUnitMaster from "./view";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  MODE_SCREEN,
} from "../../../constants/common.const";
import classText from "../../../models/control/text";
import classDdl from "../../../models/control/dropdownlist";
import SplitComponent from "../../../component/split-component/SplitComponent";
import Overlay from "../../../component/Overlay/Overlay";
import classGrid from "../../../models/control/grid";
import { handleCatchError, showMessage } from "../../../constants/utils";
import { UnitApi } from "../../../api/backend/unitMaster";
import Loading from "../../../component/Desktop/loading/loading";
import { isEmptyData } from "../../../utils/helper";
import kbn from "../../../api/backend/kbn";
import { setWidthModalColTable } from "../../../redux/sideBar";
import { useDispatch, useSelector } from "react-redux";
import rolesConst from "../../../routers/roles/roles.const";

const UnitMaster = () => {
  const [typeUnit, setTypeUnit] = useState([]);

  const unitDataOrigin = {
    unitId: new classText(""),
    unitName: new classText(""),
    quantityType: new classDdl("", typeUnit),
    displayOrder: new classText(""),
    id: new classText(""),
  };
  const originDataInstance = () => JSON.parse(JSON.stringify(unitDataOrigin));

  const [unitData, setUnitData] = useState(unitDataOrigin);
  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const [currentNode, setCurrentNode] = useState(null);
  const inputRefs = useRef({});
  const [dataSource, setDataSource] = useState(new classGrid());

  const [dataSearch, setDataSearch] = useState({ ...unitDataOrigin });
  const [loading, setLoading] = useState(false);
  const [isFillData, setIsFillData] = useState(false);
  const [firstNodeFilter, setFirstNodeFilter] = useState();
  const { collapsed } = useSelector((state) => state.sideBar);
  const [triggerWidth, setTriggerWidth] = useState(false);

  const [editData, setEditData] = useState(null);
  const [disabledEdit, setDisabledEdit] = useState(false);
  const [maxSize, setMaxSize] = useState(window.innerWidth - 400);

  const {roles} = useSelector(state => state.auth)
  const isLead  = roles === rolesConst.HEAD_OFFICE_ADMIN 

  const dispatch = useDispatch();
  const handleAdd = () => {
    const currentDisplay =
      dataSource.data.length > 0
        ? Math.max(...dataSource.data.map((i) => Number(i.displayOrder))) + 1
        : 1;
    const currenId =
      dataSource.data.length > 0
        ? Math.max(...dataSource.data.map((i) => Number(i.unitId))) + 1
        : 1;
    setMode(MODE_SCREEN.ADD);
    setUnitData({
      ...unitDataOrigin,
      quantityType: { ...unitDataOrigin.quantityType, value: "1" },
      displayOrder: new classText(""),
      unitId: new classText(currenId),
    });
    setFirstNodeFilter(null);
    setIsFillData(false);
  };

  const handleEdit = () => {
    setMode(MODE_SCREEN.EDIT);
    setIsFillData(false);
    setMode(MODE_SCREEN.EDIT);
    setDisabledEdit(true);
    setEditData(JSON.parse(JSON.stringify(unitData)));
  };

  const onCancel = () => {
    setMode(MODE_SCREEN.VIEW);
    if (!currentNode || (currentNode && isEmptyData(currentNode.id))) {
      setUnitData({ ...unitDataOrigin });
      return;
    }

    getUnitById(currentNode.id);
    setIsFillData(false);
  };
  const handleCancel = () => {
    if (isFillData) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: onCancel,
      });
    } else {
      onCancel();
    }
  };

  const showConfirmMessage = (msg, callbackOK, callbackCancel) => {
    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: callbackCancel || (() => Modal.destroyAll()),
      onOk: callbackOK || (() => Modal.destroyAll()),
    });
  };

  const validate = () => {
    let error = false;
    const data = { ...unitData };
    let firstKey = "";
    if (!String(data.unitId.value).trim()) {
      data.unitId.error = true;
      error = true;
      firstKey = "unitId";
    } else data.unitId.error = false;

    if (!data.unitName.value.trim()) {
      data.unitName.error = true;
      error = true;
      firstKey = firstKey || "unitName";
    } else data.unitName.error = false;

    setUnitData(data);
    if (inputRefs.current[firstKey]) inputRefs.current[firstKey].focus();
    return !error;
  };

  // AFFTER ADD/EDIT
  const handleAfterAddEdit = async (currentId) => {
    const listData = await getListUnit(currentId);
    if (!listData || !Array.isArray(listData)) {
      return;
    }
    const currenUnit = listData.find((i) => i.id == currentId);
    if (currenUnit) {
      onSelectList(currenUnit, true);
    }
  };
  const onSaveData = async () => {
    try {
      setLoading(true);
      const body = {
        type: unitData.quantityType.value,
        unitName: unitData.unitName.value,
        displayOrder: unitData.displayOrder.value,
        unitID: unitData.unitId.value,
      };
      if (mode === MODE_SCREEN.EDIT) {
        body.id = unitData.id.value;
      }
      let res;
      res =
        mode === MODE_SCREEN.ADD
          ? await UnitApi.createUnitMaster(body)
          : await UnitApi.updateUnitMaster(body);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, async () => {
        handleAfterAddEdit(res && res.data ? res.data : "");
      });
    } catch (error) {
      handleCatchError(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    if (!validate()) return;
    showConfirmMessage(
      mode === MODE_SCREEN.ADD
        ? COMMON_CONSTANT.BOM_C008
        : COMMON_CONSTANT.BOM_C009,
      onSaveData
    );
  };

  /// DELETE
  const showMessageDeleteConfirm = () => {
    // Action del
    const funcDel = async () => {
      try {
        await UnitApi.deleteUnitMaster(currentNode ? currentNode.id : "");
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
        setCurrentNode(null);
        getListUnit();
        setUnitData(unitDataOrigin);
      } catch (error) {
        handleCatchError(error);
      }
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
      centered: true,
    });
  };
  const getTypeValue = (typeOptions = [], type) => {
    const typeItem = typeOptions.find((i) => i.value == type || i.key == type);
    return typeItem ? typeItem.label || typeItem.value : "";
  };
  const getUnitById = async (id) => {
    try {
      setLoading(true);
      const res = await UnitApi.getUnitMasterById(id);
      if (res && res.data) {
        const dataDetail = res.data;
        const newData = { ...unitData };
        newData.unitId.value = dataDetail.unitId;
        newData.id.value = dataDetail.id;
        newData.quantityType.value = dataDetail.type;
        newData.unitName.value = dataDetail.unitName;
        newData.displayOrder.value = dataDetail.displayOrder;
        newData.quantityType.valueShow = getTypeValue(
          typeUnit,
          dataDetail.type
        );
        setUnitData(newData);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };

  const onSelectList = async (node, isFetching) => {
    if (mode !== MODE_SCREEN.VIEW && !isFetching) {
      return;
    }
    setCurrentNode(node);
    setMode(MODE_SCREEN.VIEW);
    getUnitById(node ? node.id : "");
    setFirstNodeFilter(null);
  };

  const setDataByCurrentNode = () => {
    if (currentNode) {
      setUnitData({
        unitId: new classText(currentNode.unitId),
        unitName: new classText(currentNode.unitName),
        quantityType: new classDdl(currentNode.quantityType, typeUnit),
        displayOrder: new classText(currentNode.displayOrder),
      });
    }
  };

  useEffect(() => {
    setDataByCurrentNode();
  }, [currentNode]);
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // GET LIST UNIT
  const getListUnit = async (idFocus) => {
    try {
      setLoading(true);
      const res = await UnitApi.getList();
      if (res && res.data) {
        const finalData = res.data.map(({ type, ...others }) => {
          let typeValue = "";
          const typeItem = typeUnit.find((i) => i.value == type);
          if (typeItem) {
            typeValue = typeItem.label;
          }
          return { ...others, typeValue };
        });
        setDataSource({
          ...dataSource,
          data: finalData,
          count: res.data.length,
          idFocus,
        });
        return res.data;
      }
      return null;
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getListUnit();
  }, []);

  // GET KBN
  const getKbnUnit = async () => {
    try {
      const res = await kbn.getKbnUnit();
      if (res && res.data) {
        const types = res.data.data.map(({ key, value }) => ({
          label: value,
          value: key,
        }));
        setTypeUnit(types);
      }
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getKbnUnit();
  }, []);
  // Focus First Node filter
  useEffect(() => {
    if (firstNodeFilter && mode === MODE_SCREEN.VIEW) {
      onSelectList(firstNodeFilter);
    } else if (firstNodeFilter === undefined) {
      setCurrentNode(null);
      setUnitData(originDataInstance());
    }
  }, [firstNodeFilter]);

  // GET WIDTH
  const divRef = useRef(null);
  useEffect(() => {
    if (divRef.current) {
      const width = divRef.current.getBoundingClientRect().width;
      dispatch(
        setWidthModalColTable({
          key: "unit",
          value: width,
        })
      );
    }
  }, [collapsed, triggerWidth]);

  useEffect(() => {
    const handleResize = () => {
      setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setMaxSize(collapsed ? window.innerWidth - 200 : window.innerWidth - 300);
  }, [collapsed]);

  useEffect(() => {
    if (mode === MODE_SCREEN.EDIT && editData) {
      let isChange = false;
      Object.keys(editData).forEach((key) => {
        if (editData[key].value != unitData[key].value) {
          isChange = true;
        }
      });
      setDisabledEdit(!isChange);
    }
  }, [mode, editData, unitData]);
  return (
    <div className="des-content">
      <TitlePage name={lang.UNIT_MASTER} />
      <div style={{ marginTop: 16 }}>
        <Overlay top={-28} />
        <SplitComponent
          onDragFinished={() => {
            setTriggerWidth(!triggerWidth);
          }}
          split="vertical"
          defaultSize="60%"
          minSize={40}
          maxSize={maxSize}
        >
          <div
            ref={divRef}
            className="equipment-tree-detail"
            style={{ paddingRight: 8 }}
          >
            <ListUnitMaster
              currentNode={currentNode}
              setCurrentNode={onSelectList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              dataSource={dataSource}
              setFirstNodeFilter={setFirstNodeFilter}
              mode={mode}
            />
          </div>
          <div
            className="equipment-tree-detail"
            style={{ padding: 8, background: "#fff", height: "100%" }}
          >
            <ViewUnitMaster
              unitData={unitData}
              setUnitData={setUnitData}
              currentNode={currentNode}
              mode={mode}
              inputRefs={inputRefs}
              setIsFillData={setIsFillData}
              typeList={typeUnit}
            />
          </div>
        </SplitComponent>
      </div>

      <FooterPage>
        {mode === MODE_SCREEN.VIEW ? (
          <Row justify="end">
            <Col>
              <Button
                onClick={handleAdd}
                className="buttonPC button--info wAuto ml10"
              >
                <PlusOutlined /> {lang.ADD}
              </Button>
            </Col>
            <Col>
              <Button
                disabled={!currentNode}
                onClick={handleEdit}
                className="buttonPC button--outline wAuto ml15"
              >
                <EditOutlined /> {lang.EDIT}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={showMessageDeleteConfirm}
                disabled={!currentNode || !isLead}
                className={`buttonPC ${
                  (currentNode && isLead) ? " button--error--outline" : "button--outline"
                } ml15`}
              >
                <DeleteOutlined /> {lang.DELETE}
              </Button>
            </Col>
          </Row>
        ) : (
          <Row justify="end">
            <Col>
              <Button
                disabled={mode == MODE_SCREEN.EDIT && disabledEdit}
                onClick={handleSave}
                className="buttonPC button--info wAuto ml10"
              >
                <SaveOutlined /> {lang.SAVE}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={handleCancel}
                className="buttonPC button--outline wAuto ml15"
              >
                <CloseCircleOutlined /> {lang.CANCEL}
              </Button>
            </Col>
          </Row>
        )}
      </FooterPage>
      <Loading show={loading} />
    </div>
  );
};

export default UnitMaster;
